export const VERSION = '0.5.0'
